import changeTheme from '@/utils/changeTheme'
import { getLocal } from '@/utils/tools'

const setting = getLocal('setting')

const state = {
    setting: {
      theme: setting.theme !== undefined ? setting.theme : 0,
      showTags: setting.showTags !== undefined ? setting.showTags : true,
      showLogo: setting.showLogo !== undefined ? setting.showLogo : true,
      color: {
          primary: setting.color !== undefined ? setting.color.primary : '#409eff'
      }      
    },
    menubar: {
      status: menubar !== undefined && menubar.status ? menubar.status : 0,
      isPhone: document.body.offsetWidth < 768
    }
}

const mutations = {
    CHANGE_THEME(state, num) {      
      if (num === state.setting.theme) return;
      if (typeof num !== 'number') num = state.setting.theme;
      changeTheme(num)
      state.setting.theme = num;    
      localStorage.setItem('setting', JSON.stringify(state.setting))
    },
    CHANGE_TAGS_SETTING(state, showTags) {
      state.setting.showTags = showTags
      localStorage.setItem('setting', JSON.stringify(state.setting))
  
      /*
      if(showTags) {
          const index = state.tags.tagsList.findIndex(v => v.path === router.currentRoute.value.path)
          if(index !== -1) {
              state.tags.tagsList.forEach(v => v.isActive = false)
              state.tags.tagsList[index].isActive = true
          }else{
              mutations.changeTagNavList(state, router.currentRoute.value)
          }
      }
      */
    },
    CHANGE_COLLAPSED(state) {
      state.menubar.status = state.menubar.isPhone
        ? state.menubar.status === 3
          ? 2
          : 3
        : state.menubar.status === 1
          ? 0
          : 1
    }
  }
  
  const actions = {
    changeTheme({ commit }, num) {
      commit('CHANGE_THEME', num)
    },
    changeTagsSetting({ commit }, showTags) {
      commit('CHANGE_TAGS_SETTING', showTags)
    },
    changeCollapsed({ commit }) {
      commit('CHANGE_COLLAPSED')
    }
  }
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions
  }
  